module.exports = __webpack_public_path__ + "static/building_frame_night_mobile-34ae763e6d61e8ae2f8af00d88805b5b.jpg";